import { useMemo, useState } from "react";
import Reveal from "./Reveal";
import { photoSrc } from "@/lib/api";

export default function MenuSection({ menu, site, onAdd }) {
  const categories = ["All", ...new Set(menu.map((item) => item.category))];
  const [category, setCategory] = useState("All");
  const [query, setQuery] = useState("");
  const filtered = useMemo(() => menu.filter((item) => {
    const inCategory = category === "All" || item.category === category;
    const text = `${item.name} ${item.description}`.toLowerCase();
    return inCategory && text.includes(query.toLowerCase());
  }), [category, menu, query]);

  return (
    <section className="menu-section" id="menu">
      <div className="container">
        <Reveal className="menu-heading">
          <div><span className="eyebrow">The menu</span><h2 className="section-title">Order the good stuff.</h2></div>
          <p className="menu-heading-copy">Browse the house favorites from the online menu. Your order button continues to the live Prime Pizzeria ordering system for the latest availability and delivery details.</p>
        </Reveal>
        <div className="menu-toolbar" data-testid="menu-toolbar">
          <div className="menu-tabs" role="tablist" aria-label="Menu categories">
            {categories.map((item) => <button key={item} className={`menu-tab ${category === item ? "active" : ""}`} type="button" onClick={() => setCategory(item)} data-testid={`menu-filter-${item.toLowerCase().replaceAll(" ", "-")}`}>{item}</button>)}
          </div>
          <input className="menu-search" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search the menu" aria-label="Search the menu" data-testid="menu-search-input" />
        </div>
        <div className="menu-grid" data-testid="menu-grid">
          {filtered.map((item, index) => (
            <Reveal key={item.id} className="menu-card" style={{ "--reveal-delay": `${index * 70}ms` }}>
              {item.image_url ? <img loading="lazy" className="menu-card-image" src={photoSrc(item.image_url)} alt={`${item.name} from Fucino Pizza`} data-testid={`menu-image-${item.id}`} /> : <div className="menu-card-no-image" data-testid={`menu-image-placeholder-${item.id}`}>House recipe</div>}
              <div className="menu-card-content" data-testid={`menu-item-${item.id}`}>
                <div className="menu-card-topline"><h3>{item.name}</h3><span className="menu-price">${item.price.toFixed(2)}</span></div>
                <p className="menu-description">{item.description}</p>
                {item.source_note && <p className="menu-note">{item.source_note}</p>}
                <div className="menu-card-actions">
                  <a className="menu-order-link" href={item.order_url || site.order_url} target="_blank" rel="noreferrer" data-testid={`menu-item-order-${item.id}`}>View in live menu ↗</a>
                  <button className="btn btn-dark btn-small" type="button" onClick={() => onAdd(item)} data-testid={`menu-item-add-${item.id}`}>Add preview</button>
                </div>
              </div>
            </Reveal>
          ))}
          {!filtered.length && <div className="menu-empty" data-testid="menu-empty-state">No menu item matches that search.</div>}
        </div>
        <div className="menu-footer"><p>Prices and availability can change in the live ordering system.</p><a className="btn btn-primary btn-small" href={site.order_url} target="_blank" rel="noreferrer" data-testid="menu-full-order-link">View full menu ↗</a></div>
      </div>
    </section>
  );
}
